<template>
  <span v-if="!!model">{{ model | isoStringToDate | formatDateTime }}</span>
</template>

<script>
import BaseFormComponent from './component.vue';

export default class BaseFormComponentCardDateField extends BaseFormComponent {}
</script>
